import React from "react";
import PropTypes from "prop-types";

import withStyles from '@mui/styles/withStyles';

import TextField from '@mui/material/TextField';


export const AdresseFormModes = {
    Complet: 'complet',
    Simple: 'simple',
    Basique: 'basique',
};

const styles = theme => ({

    textField: {
        marginBottom: theme.spacing(1)
    },
});


const AdresseForm = ({ classes, onChange, label, adresse, mode, autoFocus }) => {

    const [nom, setNom] = React.useState(adresse && (mode === AdresseFormModes.Complet) ? adresse.nom : adresse && (mode === AdresseFormModes.Complet) ? adresse.libelle : '');
    const [adresse1, setAdresse1] = React.useState(adresse && (mode === AdresseFormModes.Complet) ? adresse.adresse1 : '');
    const [adresse2, setAdresse2] = React.useState(adresse && (mode === AdresseFormModes.Complet) ? adresse.adresse2 : '');
    const [codePostal, setCodePostal] = React.useState(adresse && (mode === AdresseFormModes.Complet) ? adresse.codePostal : '');
    const [ville, setVille] = React.useState(adresse && (mode === AdresseFormModes.Complet) ? adresse.ville : '');

    const [adresseSimple, setAdresseSimple] = React.useState(adresse && (mode !== AdresseFormModes.Complet) ? adresse.adresse : '');

    React.useEffect(() => {
        handleChange();
    }, [nom, adresse1, adresse2, codePostal, ville, adresseSimple]);


    const adresseToString = (addr) => {

        if (mode === AdresseFormModes.Basique) {
            return addr.adresse;
        }

        if (mode === AdresseFormModes.Simple) {

            if (!(addr.libelle && addr.adresse)) {
                return '';
            }

            let result = addr.libelle;

            if (addr.adresse) {
                result += '\n';
                result += addr.adresse;
            }

            return result;
        }

        if (!(addr.nom && (addr.adresse1 || addr.adresse2) && addr.codePostal && addr.ville)) {
            return '';
        }

        let result = addr.nom;

        if (addr.adresse1) {
            result += '\n';
            result += addr.adresse1;
        }

        if (addr.adresse2) {
            result += '\n';
            result += addr.adresse2;
        }

        result += `\n${addr.codePostal} ${addr.ville}`;

        return result;
    }

    const handleChange = () => {

        let nouvelleAdresse = { nom, adresse1, adresse2, codePostal, ville };
        if (mode === AdresseFormModes.Simple) {
            nouvelleAdresse = { libelle: nom, adresse: adresseSimple };
        }
        if (mode === AdresseFormModes.Basique) {
            nouvelleAdresse = { adresse: adresseSimple };
        }

        let libelle = adresseToString(nouvelleAdresse);

        //console.log("handleChange", nouvelleAdresse, libelle);

        onChange(nouvelleAdresse, libelle);
    };


    return (
        <fieldset style={{ borderRadius: '8px', backgroundColor: 'rgb(250, 250, 250)', width: '100%' }}>
            <legend>{label}</legend>


                {(mode !== AdresseFormModes.Basique) && (
                    <TextField
                        className={classes.textField}
                        label={adresseSimple ? "Libellé" : "Nom"}
                        value={nom}
                        onChange={e => { setNom(e.target.value); }}
                        fullWidth
                        variant={"filled"}
                        autoFocus={autoFocus}
                    />
                )}


                {(mode !== AdresseFormModes.Complet) && (
                    <TextField
                        className={classes.textField}
                        label={"Adresse"}
                        value={adresseSimple}
                        multiline
                        rows={3}
                        onChange={e => { setAdresseSimple(e.target.value); }}
                        fullWidth
                        variant={"filled"}
                        autoFocus={autoFocus && mode === AdresseFormModes.Basique}
                    />
                )}

                {(mode === AdresseFormModes.Complet) && (
                    <React.Fragment>
                        <TextField
                            className={classes.textField}
                            label={"Adresse"}
                            value={adresse1}
                            onChange={e => { setAdresse1(e.target.value); }}
                            fullWidth
                            variant={"filled"}
                        />
                        <TextField
                            className={classes.textField}
                            label={"Complément"}
                            value={adresse2}
                            onChange={e => { setAdresse2(e.target.value); }}
                            fullWidth
                            variant={"filled"}
                        />
                        <TextField
                            className={classes.textField}
                            label={"Code postal"}
                            value={codePostal}
                            onChange={e => { setCodePostal(e.target.value); }}
                            fullWidth
                            variant={"filled"}
                        />
                        <TextField
                            className={classes.textField}
                            label={"Ville"}
                            value={ville}
                            onChange={e => { setVille(e.target.value); }}
                            fullWidth
                            variant={"filled"}
                        />
                    </React.Fragment>
                )}


        </fieldset>
    );
}



AdresseForm.propTypes = {
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    adresse: PropTypes.object,
    mode: PropTypes.string,
};

AdresseForm.defaultProps = {
    label: "Adresse",
    mode: AdresseFormModes.Complet, // Complet : nom, adresse1, adresse2, CP et ville.  // simple : libelle et adresse  // Basique : adresse
    autoFocus: false,
    //adresse: {
    //    nom: '',
    //    adresse1: '',
    //    adresse2: '',
    //    codePostal: '',
    //    ville: ''
    //},
};

export default withStyles(styles)(AdresseForm);


